module.exports = __webpack_public_path__ + "static/sulamerica-0cda998a185dd60a5b92976cb932d11b.png";